import { Component, inject, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { HomeFilter } from 'src/app/models/client-configuration';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { UserService } from '../../services/user.service';
import { UserActions } from '../../models/user-actions';
import { AuthService } from 'src/app/services/auth.service';
import { CollectionsFacade } from '../../state/collections/collections.facade';
import { map } from 'rxjs/operators';
import { UserFacade } from 'src/app/_core/state/user/user.facade';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss'],
})
export class CollectionsComponent implements OnInit {
  private readonly userFacade = inject(UserFacade);

  readonly firstCollection$ = this.collectionsFacade.collections$.pipe(map((collections) => collections[0]));
  readonly restCollections$ = this.collectionsFacade.collections$.pipe(map((collections) => collections.slice(1)));
  readonly collectionsLength$ = this.collectionsFacade.collections$.pipe(map((collections) => collections.length));

  filter: HomeFilter;
  loading = true;
  loggedUser = null;
  tagCloudPosition: number;
  showSliderUserActions: boolean;
  showActiveCheckoutsCarousel: boolean;
  canCreateUserGroups: boolean = false;
  activeRecordOrder: number;
  isManagementHubActive: boolean;

  @Input()
  userActions: UserActions[] = [];

  constructor(
    private readonly configService: ConfigService,
    private readonly localeService: LocaleService,
    private readonly broadcastService: BroadcastService,
    private readonly userService: UserService,
    private readonly authService: AuthService,
    private readonly collectionsFacade: CollectionsFacade
  ) {
    this.filter = configService.get().homeFilter;
    this.showSliderUserActions = configService.get().showSliderUserActions;
    this.isManagementHubActive = configService.get().managementHubAvailable;
  }

  ngOnInit() {
    this.loggedUser = this.userFacade.user;
    this.showActiveCheckoutsCarousel = this.configService.get().showActiveRecordsCarousel;
    this.activeRecordOrder = this.configService.get().activeRecordsOrder ?? 0;

    if (this.collectionsFacade.collections.length === 0) {
      this.collectionsFacade.clearStore();
      this.loadCollections();
    } else {
      this.onCollections();
    }

    this.loadSessionBookClubs();
    this.loadOleConfiguration();
  }

  private loadCollections(): void {
    this.collectionsFacade.getCollections(this.localeService.language).subscribe(() => {
      this.onCollections();
    });
  }

  private onCollections(): void {
    setTimeout(() => (this.loading = false), 50);
    this.tagCloudPosition = Math.floor(this.collectionsFacade.collections.length / 2);
  }

  private loadSessionBookClubs() {
    const cachedBookClubs = sessionStorage.getItem(Util.BOOKCLUBS_KEY);
    try {
      this.userService.bookClubsCollection = JSON.parse(cachedBookClubs);
    } catch (e) {
      sessionStorage.removeItem(Util.BOOKCLUBS_KEY);
    } finally {
      if (this.authService.isAuthenticated() && this.configService.get().bookClubUrl) {
        this.userService.loadBookClubs();
      }
    }
  }

  private loadOleConfiguration(): void {
    if (this.authService.isAuthenticated() && this.configService.get().bookClubUrl) {
      this.userService.getOleConfiguration();
      this.broadcastService.sliderUserActions$.subscribe(() => {
        this.userActions = this.userService.userActions;
        this.canCreateUserGroups = this.userFacade.user?.canCreateUserGroups ?? false;
      });
    } else {
      this.canCreateUserGroups = this.userFacade.user?.canCreateUserGroups ?? false;
    }
  }
}
